import React, { useState } from "react";
import { Grid, Box, Button, InputBase } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { useForm } from "react-hook-form";
import { serverUrl, trackingBaseUrl } from "../../utils/constants";
import AlertDialog from "../../compnents/Modal/AlertDialog";
import axios from "axios";
import logo from "../../assets/RCS.png";
import "./Hero.css";

const theme = createTheme({
  typography: {
    subtitle: {
      fontSize: 12,
    },
    body1: {
      fontWeight: 900,
    },
    button: {
      fontStyle: "italic",
    },
  },
});

function HeroSection({ onChangeShipperState }) {
  const { register, handleSubmit, reset } = useForm();
  const [click, setClick] = useState(false);
  const [alert_, setalert] = useState(false);

  const trackResult = async (data_) => {
    // Basic sanitization: trim and remove special chars that might be XSS
    const cleanTrackingNumber = data_.tracking_number.trim().replace(/[^a-zA-Z0-9-]/g, "");

    if (!cleanTrackingNumber) return;

    setClick(true);
    setalert(false);
    axios
      .get(`${trackingBaseUrl}/shipment/${cleanTrackingNumber}`)
      .then(function (response) {
        if (response.data) {
          if (response.data.shipment == null) {
            setClick(false);
            setalert(true);
            return

          }
          setClick(false);
          onChangeShipperState(response.data);
          reset();
        } else {
          setClick(false);
          setalert(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div className="hero">
      {/* Flying Planes with Logo */}
      <div className="flying-plane">
        <div className="plane-container">
          <span className="plane-icon">✈️</span>
          <img src={logo} alt="RCS Express" className="flying-logo" />
        </div>
      </div>
      <div className="flying-plane-2">
        <div className="plane-container">
          <span className="plane-icon">✈️</span>
          <img src={logo} alt="RCS Express" className="flying-logo" />
        </div>
      </div>

      {/* Floating Clouds */}
      <div className="cloud cloud-1">☁️</div>
      <div className="cloud cloud-2">☁️</div>
      <div className="cloud cloud-3">☁️</div>

      <ThemeProvider theme={theme}>
        <Grid
          container
          width={"100%"}
          direction="column"
          justifyContent="center"
          alignItems="center"
          padding={{ xs: "20px", md: "40px" }}
        >
          <Grid item padding={{ xs: "10px", md: "20px" }}>
            <Box className="looking">
              looking to <span className="move">move?</span>
            </Box>
          </Grid>
          <Grid item padding={"10px"}>
            <Box className="quality">quality without question.</Box>
          </Grid>
          <Grid item padding={"10px"}>
            <Box className="hassle">
              Your hassle-free delivery experience starts here.
            </Box>
          </Grid>
          <form onSubmit={handleSubmit(trackResult)} style={{ width: "100%" }}>
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ width: "100%" }}
            >
              <Grid
                item
                xs={12}
                md={10}
                lg={8}
                className="hero-form-container"
              >
                <Grid
                  container
                  spacing={2}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Grid item xs={12} md={8}>
                    <InputBase
                      name="tracking_number"
                      {...register("tracking_number", { required: true })}
                      placeholder="Enter Tracking Number"
                      size="medium"
                      sx={{
                        padding: "16px 28px",
                        width: "100%",
                        background: "white",
                        border: "2px solid #f0f0f0",
                        boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
                        borderRadius: "8px",
                        fontFamily: "Montserrat",
                        fontSize: "18px",
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                        "&:hover": {
                          border: "2px solid #03A9F4",
                          boxShadow: "0px 12px 32px rgba(2, 119, 189, 0.2)",
                        },
                        "&:focus-within": {
                          border: "2px solid #0277BD",
                          boxShadow: "0px 12px 40px rgba(2, 93, 158, 0.3)",
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="outlined"
                      type="submit"
                      className="modern-button"
                      sx={{
                        width: "100%",
                        height: "56px",
                        padding: "14px 32px",
                        background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 100%)",
                        border: "none",
                        borderRadius: "8px",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        boxShadow: "0px 16px 48px -12px rgba(2, 119, 189, 0.6)",
                        color: "white",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        ":hover": {
                          background: "linear-gradient(135deg, #0277BD 0%, #025D9E 100%)",
                          transform: "translateY(-2px)",
                          boxShadow: "0px 20px 60px -10px rgba(2, 93, 158, 0.8)",
                        },
                        ":active": {
                          transform: "translateY(0px)",
                        }
                      }}
                    >
                      {click ? (
                        <CircularProgress size={24} sx={{ color: "white" }} />
                      ) : (
                        "Track Result"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </ThemeProvider>

      {alert_ && (
        <AlertDialog message={"We are unable to fetch your data at the moment , please contact customer support"} alert={alert_} />
      )}
    </div>
  );
}

export default HeroSection;
